export const intakeRulesPtBr = {
  card: {
    button: 'Regras',
    title: 'Regras de entrada',
    description: 'Defina como os dados de e-mails estruturados direcionam contas e classificações.',
    empty: 'Nenhuma regra de entrada configurada.',
    loading: 'Carregando regras de entrada...',
    error: 'Não foi possível carregar as regras de entrada.',
    create: 'Nova regra',
    prompt: 'Descreva a regra',
    promptPlaceholder: 'Ex.: cartões do Societário devem ir para a Caveo Contabilidade',
    propose: 'Gerar proposta',
    proposing: 'Gerando proposta...',
    deletedInbox: 'Caixa de entrada removida',
    inboxUnavailable: 'Caixa de entrada indisponível',
    lastMatchedUnavailable: 'Ainda não disponível',
  },
  fields: {
    name: 'Nome',
    priority: 'Prioridade',
    scope: 'Escopo',
    active: 'Ativa',
    lastMatched: 'Última correspondência',
    conditions: 'Condições',
    actions: 'Ações',
    target: 'Destino',
    value: 'Valor',
    valueMode: 'Origem do valor',
    operator: 'Operador',
    field: 'Campo',
    literal: 'Valor fixo',
    sourceField: 'Campo do e-mail',
    freeField: 'Outro campo',
    inbox: 'Caixa de entrada',
    source: 'Fonte',
  },
  dialog: {
    backToList: 'Voltar para a lista',
    close: 'Fechar',
    createTitle: 'Nova regra de entrada',
    editTitle: 'Editar regra de entrada',
    save: 'Salvar',
    cancel: 'Cancelar',
    addCondition: 'Adicionar condição',
    addAction: 'Adicionar ação',
    validation: 'Informe um nome, ao menos uma condição e uma ação.',
    textLimit: 'O texto do segmento deve ter no máximo 200 caracteres.',
  },
  editor: {
    allInboxes: 'Todas as caixas de entrada',
    unseenFields_one:
      'A caixa selecionada nunca recebeu o campo {{fields}}. Esta regra não será aplicada enquanto isso não mudar.',
    unseenFields_other:
      'A caixa selecionada nunca recebeu os campos {{fields}}. Esta regra não será aplicada enquanto isso não mudar.',
    allSources: 'Todas as fontes',
    customField: 'Nome do outro campo',
    segmentId: 'ID do segmento',
    selectSegment: 'Selecione o segmento',
    manualSegmentId: 'Digitar ID manualmente',
    entityPlaceholder: 'Selecione a entidade',
    selectEntityFirst: 'Defina a entidade primeiro',
    entityRequiredForScopedTargets:
      'Estes valores pertencem a uma única entidade; a regra precisa informar essa entidade primeiro.',
    entityScopedByInbox:
      'Estes valores estão limitados à entidade da caixa de entrada selecionada.',
    booleanTrue: 'Sim',
    booleanFalse: 'Não',
    destinationPlaceholder: 'Selecione o destino',
    destinationOptions: {
      COST_PROVISION: 'Baixa de provisão de custo',
    },
  },
  review: {
    title: 'Revise as propostas',
    rationale: 'Justificativa',
    matches: 'corresponde a {{matched}} de {{total}} e-mails da amostra mais recente (até 200)',
    matchesSample:
      'Corresponde a {{matched}} de {{total}} e-mails da amostra mais recente (até 200).',
    noSample: 'Ainda não há histórico de entrada estruturada para estimar o impacto.',
    save: 'Salvar',
    invalid: 'Esta proposta não pode ser salva.',
    saved: 'Regra salva.',
    error: 'Não foi possível salvar a regra.',
    empty: 'Nenhuma proposta foi gerada para esta descrição.',
  },
  actions: {
    edit: 'Editar',
    delete: 'Excluir',
    activate: 'Ativar',
    deactivate: 'Desativar',
    active: 'Ativa',
    inactive: 'Inativa',
    deleteTitle: 'Excluir regra de entrada?',
    deleteDescription: 'A regra "{{name}}" será removida e não será mais aplicada.',
    confirmDelete: 'Excluir',
    saved: 'Regra de entrada salva.',
    deleted: 'Regra de entrada excluída.',
  },
  sources: { pipefy: 'Pipefy', email: 'E-mail' },
  conditionFields: { subject: 'Assunto', sender: 'Remetente', body: 'Corpo', source: 'Fonte' },
  operators: {
    equals: 'é igual a',
    not_equals: 'não é igual a',
    in: 'está em',
    not_in: 'não está em',
    contains: 'contém',
    matches: 'corresponde ao padrão',
    is_empty: 'está vazio',
    is_not_empty: 'não está vazio',
  },
  targets: {
    bill: {
      entityId: 'Entidade',
      description: 'Descrição',
      memo: 'Observação',
      billCompetencyDate: 'Data de competência',
      paymentMethod: 'Método de pagamento',
      currencyCode: 'Moeda',
      tags: 'Etiquetas',
      isUrgent: 'Urgente',
    },
    classification: {
      departmentId: 'Departamento',
      costCenterId: 'Centro de custo',
      glAccountId: 'Conta contábil',
      managerialAccountId: 'Conta gerencial',
    },
    payment: {
      originBankAccountId: 'Conta bancária de origem',
      paymentMethod: 'Método de pagamento',
      scheduledDate: 'Data programada',
    },
    line: {
      destination: 'Destino das linhas (provisão de custo)',
    },
    segment: 'Segmento personalizado',
  },
  errors: {
    INTAKE_RULE_NOT_FOUND: 'Regra de entrada não encontrada.',
    INTAKE_RULE_TARGET_NOT_FOUND:
      'O valor informado não corresponde a um registro ativo do catálogo.',
    INTAKE_RULE_TARGET_ENTITY_MISMATCH:
      'O registro selecionado pertence a uma entidade diferente da definida pela regra.',
    INTAKE_RULE_SEGMENT_NOT_TEXT:
      'Texto livre só é permitido para segmentos de texto sem valores predefinidos.',
    INTAKE_RULE_PATTERN_INVALID: 'O padrão é inválido ou excede 100 caracteres.',
    INTAKE_RULE_FIELD_REQUIRED: 'Campo obrigatório ausente na regra de entrada.',
    INTAKE_RULE_INBOX_NOT_FOUND: 'A caixa de entrada informada não existe neste tenant.',
    INTAKE_RULE_PROPOSAL_MALFORMED:
      'Não foi possível interpretar esta proposta de regra gerada por IA.',
    INTAKE_RULE_COMPILER_FAILED: 'Não foi possível gerar propostas agora. Tente novamente.',
  },
  bill: { label: 'Regras de entrada', settings: 'Ver regras de entrada' },
} as const;

export const intakeRulesEn = {
  card: {
    button: 'Rules',
    title: 'Intake rules',
    description: 'Define how structured email data routes bills and classifications.',
    empty: 'No intake rules configured.',
    loading: 'Loading intake rules...',
    error: 'Could not load intake rules.',
    create: 'New rule',
    prompt: 'Describe the rule',
    promptPlaceholder: 'Example: corporate cards should go to the holding entity',
    propose: 'Generate proposal',
    proposing: 'Generating proposal...',
    deletedInbox: 'Deleted inbox',
    inboxUnavailable: 'Inbox unavailable',
    lastMatchedUnavailable: 'Not available yet',
  },
  fields: {
    name: 'Name',
    priority: 'Priority',
    scope: 'Scope',
    active: 'Active',
    lastMatched: 'Last matched',
    conditions: 'Conditions',
    actions: 'Actions',
    target: 'Target',
    value: 'Value',
    valueMode: 'Value source',
    operator: 'Operator',
    field: 'Field',
    literal: 'Fixed value',
    sourceField: 'Email field',
    freeField: 'Other field',
    inbox: 'Inbox',
    source: 'Source',
  },
  dialog: {
    backToList: 'Back to the list',
    close: 'Close',
    createTitle: 'New intake rule',
    editTitle: 'Edit intake rule',
    save: 'Save',
    cancel: 'Cancel',
    addCondition: 'Add condition',
    addAction: 'Add action',
    validation: 'Provide a name, at least one condition, and one action.',
    textLimit: 'The segment text must be at most 200 characters.',
  },
  editor: {
    allInboxes: 'All inboxes',
    unseenFields_one:
      'The selected inbox has never received the field {{fields}}. This rule will not apply until that changes.',
    unseenFields_other:
      'The selected inbox has never received the fields {{fields}}. This rule will not apply until that changes.',
    allSources: 'All sources',
    customField: 'Other field name',
    segmentId: 'Segment ID',
    selectSegment: 'Select the segment',
    manualSegmentId: 'Type the ID manually',
    entityPlaceholder: 'Select an entity',
    selectEntityFirst: 'Set the entity first',
    entityRequiredForScopedTargets:
      'These values belong to a single entity; the rule must name that entity first.',
    entityScopedByInbox: 'These values are scoped to the selected inbox’s entity.',
    booleanTrue: 'Yes',
    booleanFalse: 'No',
    destinationPlaceholder: 'Select the destination',
    destinationOptions: {
      COST_PROVISION: 'Cost provision settlement',
    },
  },
  review: {
    title: 'Review proposals',
    rationale: 'Rationale',
    matches: 'matches {{matched}} of {{total}} emails in the latest sample (up to 200)',
    matchesSample: 'Matches {{matched}} of {{total}} emails in the latest sample (up to 200).',
    noSample: 'There is no structured intake history yet to estimate this rule’s impact.',
    save: 'Save',
    invalid: 'This proposal cannot be saved.',
    saved: 'Rule saved.',
    error: 'Could not save rule.',
    empty: 'No proposals were generated for this description.',
  },
  actions: {
    edit: 'Edit',
    delete: 'Delete',
    activate: 'Activate',
    deactivate: 'Deactivate',
    active: 'Active',
    inactive: 'Inactive',
    deleteTitle: 'Delete intake rule?',
    deleteDescription: 'The rule "{{name}}" will be removed and will no longer apply.',
    confirmDelete: 'Delete',
    saved: 'Intake rule saved.',
    deleted: 'Intake rule deleted.',
  },
  sources: { pipefy: 'Pipefy', email: 'Email' },
  conditionFields: { subject: 'Subject', sender: 'Sender', body: 'Body', source: 'Source' },
  operators: {
    equals: 'equals',
    not_equals: 'does not equal',
    in: 'is one of',
    not_in: 'is not one of',
    contains: 'contains',
    matches: 'matches pattern',
    is_empty: 'is empty',
    is_not_empty: 'is not empty',
  },
  targets: {
    bill: {
      entityId: 'Entity',
      description: 'Description',
      memo: 'Memo',
      billCompetencyDate: 'Competency date',
      paymentMethod: 'Payment method',
      currencyCode: 'Currency',
      tags: 'Tags',
      isUrgent: 'Urgent',
    },
    classification: {
      departmentId: 'Department',
      costCenterId: 'Cost center',
      glAccountId: 'GL account',
      managerialAccountId: 'Managerial account',
    },
    payment: {
      originBankAccountId: 'Origin bank account',
      paymentMethod: 'Payment method',
      scheduledDate: 'Scheduled date',
    },
    line: {
      destination: 'Line destination (cost provision)',
    },
    segment: 'Custom segment',
  },
  errors: {
    INTAKE_RULE_NOT_FOUND: 'Intake rule not found.',
    INTAKE_RULE_TARGET_NOT_FOUND: 'The value does not match an active catalog record.',
    INTAKE_RULE_TARGET_ENTITY_MISMATCH:
      'The selected record belongs to a different entity than the rule.',
    INTAKE_RULE_SEGMENT_NOT_TEXT:
      'Free text is only allowed for text segments without predefined values.',
    INTAKE_RULE_PATTERN_INVALID: 'The pattern is invalid or exceeds 100 characters.',
    INTAKE_RULE_FIELD_REQUIRED: 'A required field is missing from the intake rule.',
    INTAKE_RULE_INBOX_NOT_FOUND: 'The inbox does not belong to this tenant.',
    INTAKE_RULE_PROPOSAL_MALFORMED: 'This AI-generated rule proposal could not be understood.',
    INTAKE_RULE_COMPILER_FAILED: 'Could not generate proposals right now. Please try again.',
  },
  bill: { label: 'Intake rules', settings: 'View intake rules' },
} as const;
